import {
   ADD_PRINT_FORMATS,
   CLEAR_ONE_PRINT,
   DELETE_PRINT_FORMATS,
   GET_ONE_CUSTOMER,
   GET_ONE_PRINT,
   GET_PRINT_FORMATS,
   UPDATE_PRINT_FORMATS,
} from '../types';

const customPrint = { list: [], single: null };

const reducer = (state = customPrint, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_PRINT_FORMATS:
         return { ...state, list: payload };

      case UPDATE_PRINT_FORMATS:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_PRINT_FORMATS:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_PRINT_FORMATS:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ONE_PRINT:
         return { ...state, single: payload };

      case CLEAR_ONE_PRINT:
         return { ...state, single: null };

      default:
         return state;
   }
};

export default reducer;
